export class EmployeesConst {
    public static headerTable = [
        {
            field: "name",
            title: "Nombre",
            cell: (row) => `${row.name}`,
            class: (row) => ``,
        },
        {
            field: "dni",
            title: "DNI",
            cell: (row) => (row.dni !== null ? `${row.dni}` : "-"),
            class: (row) => ``,
        },
        {
            field: "category",
            title: "Categoria",
            cell: (row) => (row.category !== null ? `${row.category}` : "-"),
            class: (row) => ``,
        },
        {
            field: "datosAccesoConfigurados",
            title: "Acceso configurado",
            cell: (row) => (row.datosAccesoConfigurados ? `Sí` : `No`),
            class: (row) => ``,
        },
        {
            field: "active",
            title: "Activo",
            cell: (row) => (row.active ? `Sí` : `No`),
            class: (row) => ``,
        },
        {
            field: "activarGeolocalizacion",
            title: "Geolocalización",
            cell: (row) => (row.activarGeolocalizacion ? `Sí` : `No`),
            class: (row) => ``,
        },
    ];
}

export const EMPLOYEES_MARITAL_STATUS: { [key: string]: number } = {
    "Soltero/a": 1,
    "Casado/a": 2,
    "Divorciado/a": 3,
    "Viudo/a": 4,
};
export const EMPLOYEES_CHILDREN: { [key: string]: number } = {
    Uniparental: 1,
    Biparental: 2,
    "Familia numerosa": 3,
};
export const EMPLOYEES_PROPERTY_TYPE: { [key: string]: number } = {
    Alquiler: 1,
    Hipoteca: 2,
    Otros: 3,
};
export const EMPLOYEES_CONTRACT_TYPE: { [key: string]: number } = {
    Indefinido: 1,
    Temporal: 2,
    Formación: 3,
    Prácticas: 4,
};
export const EMPLOYEES_WORKDAY: { [key: string]: number } = {
    Completa: 1,
    "Tiempo parcial o media jornada": 2,
};

export const EMPLOYEES_ROUTES = [
    { label: "Personal", link: "/employees", enable: true },
    { label: "Gastos por empleado", link: "/employees/gastos", enable: true },
    {
        label: "Turnos y registros de horas",
        link: "/employees/turnos",
        enable: true,
    },
    { label: "Bajas", link: "/employees/bajas", enable: true },
    { label: "Vacaciones", link: "/employees/vacaciones", enable: true },
];
